import _defineProperty from "/src/main/react/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _jsxFileName = "/src/main/react/src/main/app/components/pages/AdminPortal.js";
import React from 'react';
import TpicPage from './TpicPage';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { BASE_URIS, Q_STRING } from "../domain/constants";
import { AppBar, Grid, Paper, Tab, Tabs } from "@material-ui/core";
import { ManageUser, UserTable } from "../admin";
import queryString from "query-string";
import { MODE } from "../admin/ManageUser";
import { changeSearchValues, retrieveFromQueryString, setUpTabInfoFromQueryString } from "../../util/QueryStringUtil";
const styles = () => ({
  centeredContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto',
    maxWidth: '80vw',
    minWidth: '80vw'
  }
});
class AdminPortal extends TpicPage {
  constructor(props) {
    super(props);
    _defineProperty(this, "handleTabChange", (event, value) => {
      this.setState({
        tabValue: value
      });
      let params = {};
      params[Q_STRING.TAB] = value;
      changeSearchValues(params, this.props);
    });
    const querystringValues = queryString.parse(this.props.location.search);
    const tab = determineTabValueFromQueryString(querystringValues);
    this.state = {
      adminRoleVerified: false,
      forbidden: false,
      tabValue: tab !== -1 ? tab : tabVals.CREATE_USER
    };
    this.verifyAdminRole();
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    const defaultValue = tabVals.CREATE_USER;
    const querystringValues = queryString.parse(this.props.location.search);
    const tabValueFromQString = determineTabValueFromQueryString(querystringValues);
    setUpTabInfoFromQueryString(this, prevState, defaultValue, querystringValues, tabValueFromQString);
  }
  verifyAdminRole() {
    // Users can mess with the role in the localStorage, but they (hopefully) can't mess with application memory
    fetch(BASE_URIS.isAdmin, {
      method: 'GET',
      credentials: 'include'
    }).then(resp => {
      if (resp !== null && resp.status !== null) {
        if (resp.status === 200) {
          this.setState({
            adminRoleVerified: true
          });
        } else {
          this.setState({
            forbidden: true
          });
        }
      }
    });
  }
  render() {
    const _this$state = this.state,
      tabValue = _this$state.tabValue,
      adminRoleVerified = _this$state.adminRoleVerified,
      forbidden = _this$state.forbidden;
    const classes = this.props.classes;
    if (forbidden === true) {
      return /*#__PURE__*/React.createElement("div", {
        className: classes.centeredContainer,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 68,
          columnNumber: 17
        }
      }, /*#__PURE__*/React.createElement("h1", {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 69,
          columnNumber: 21
        }
      }, "You are forbidden from viewing this page"));
    } else if (adminRoleVerified !== true) {
      return /*#__PURE__*/React.createElement("div", {
        className: classes.centeredContainer,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 74,
          columnNumber: 17
        }
      }, /*#__PURE__*/React.createElement("h1", {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 75,
          columnNumber: 21
        }
      }, "Verifying that you're an admin..."));
    } else {
      return /*#__PURE__*/React.createElement("div", {
        className: classes.centeredContainer,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 80,
          columnNumber: 17
        }
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        direction: "column",
        spacing: 1,
        justify: "space-around",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 81,
          columnNumber: 21
        }
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        container: true,
        direction: "column",
        alignContent: "center",
        justify: "center",
        spacing: 5,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 82,
          columnNumber: 25
        }
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 83,
          columnNumber: 29
        }
      }, /*#__PURE__*/React.createElement(Paper, {
        elevation: 0,
        style: {
          marginTop: '3vh',
          minWidth: '80vw',
          maxWidth: '80vw',
          overflow: 'hidden'
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 84,
          columnNumber: 33
        }
      }, /*#__PURE__*/React.createElement(AppBar, {
        position: "sticky",
        style: {
          overflow: 'hidden'
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 85,
          columnNumber: 37
        }
      }, /*#__PURE__*/React.createElement(Tabs, {
        value: tabValue,
        variant: "scrollable",
        onChange: this.handleTabChange,
        style: {
          overflow: 'hidden'
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 86,
          columnNumber: 41
        }
      }, /*#__PURE__*/React.createElement(Tab, {
        label: "Create User",
        value: tabVals.CREATE_USER,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 87,
          columnNumber: 45
        }
      }), /*#__PURE__*/React.createElement(Tab, {
        label: "View/Manage Users",
        value: tabVals.VIEW_USERS,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 88,
          columnNumber: 45
        }
      }))), tabVals.CREATE_USER === tabValue && /*#__PURE__*/React.createElement(ManageUser, {
        mode: MODE.CREATE,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 92,
          columnNumber: 37
        }
      }), tabVals.VIEW_USERS === tabValue && /*#__PURE__*/React.createElement(UserTable, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 95,
          columnNumber: 37
        }
      }))))));
    }
  }
}
function determineTabValueFromQueryString(querystringValues) {
  let tab = retrieveFromQueryString(Q_STRING.TAB, querystringValues);
  const allTabValues = Object.values(tabVals);
  if (allTabValues.includes(tab)) {
    return tab;
  } else {
    return -1;
  }
}
const tabVals = {
  CREATE_USER: 'cu',
  VIEW_USERS: 'vu'
};
export default withStyles(styles)(withRouter(AdminPortal));